import React from 'react';
import { useQuery } from '@apollo/client';
import moment from 'moment';
import { getLocationDeliverectSalesDataQuery } from './queries';
import OrderStatsSection from '../../../../../components/OrderStatsSection';

interface Props {
  locationId: string;
  dateRange: { startDate: Date | null; endDate: Date | null };
  customDateValid: boolean;
  classes: any;
}

const DeliverectOrderSection: React.FC<Props> = ({ locationId, dateRange, customDateValid, classes }) => {
  const { data, loading } = useQuery(
    getLocationDeliverectSalesDataQuery(
      locationId,
      dateRange.startDate ? moment(dateRange.startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss') : '',
      dateRange.endDate ? moment(dateRange.endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss') : ''
    ),
    {
      fetchPolicy: 'no-cache',
      skip: !locationId || !customDateValid,
    }
  );

  const orders = data?.locations_by_pk?.orders_deliverect || [];
  const aggregate = data?.locations_by_pk?.orders_deliverect_aggregate?.aggregate;

  const salesByDate = orders.reduce((acc: Record<string, number>, order: any) => {
    const date = moment(order.created_at).format('YYYY-MM-DD');
    if (!acc[date]) acc[date] = 0;
    acc[date] += order.total || 0;
    return acc;
  }, {} as Record<string, number>);
  const ordersCountByDate = orders.reduce((acc: Record<string, number>, order: any) => {
    const date = moment(order.created_at).format('YYYY-MM-DD');
    if (!acc[date]) acc[date] = 0;
    acc[date] += 1;
    return acc;
  }, {} as Record<string, number>);

  const metrics = {
    totalSales: aggregate?.sum?.total || 0,
    totalOrders: aggregate?.count || 0,
    avgOrderValue: aggregate?.count > 0 ? aggregate?.sum?.total / aggregate?.count : 0,
  };

  const tableColumns = [
    { key: '#', label: '#', render: (_: any, idx: number) => idx + 1 },
    { key: 'order_number', label: 'Order Number' },
    { key: 'created_at', label: 'Date', render: (order: any) => moment(order.created_at).format('YYYY-MM-DD HH:mm') },
    { key: 'total', label: 'Total', render: (order: any) => `£${(order.total / 100).toFixed(2)}` },
    { key: 'delivery_cost', label: 'Delivery Cost', render: (order: any) => `£${(order.delivery_cost / 100).toFixed(2)}` },
    { key: 'service_charge', label: 'Service Charge', render: (order: any) => `£${(order.service_charge / 100).toFixed(2)}` },
    { key: 'deliverect_status', label: 'Status', render: (order: any) => order.deliverect_status || '-' },
  ];

  return (
    <OrderStatsSection
      loading={loading}
      metrics={metrics}
      salesByDate={salesByDate}
      ordersCountByDate={ordersCountByDate}
      orders={orders}
      tableColumns={tableColumns}
      classes={classes}
    />
  );
};

export default DeliverectOrderSection;
